import React from 'react';
import { Link } from 'react-router-dom';
import { AuthSwitch } from '../data';

const Header = () => (
  <header>
    <nav>
      <ul>
        <li><Link to='/'>Home</Link></li>
        <AuthSwitch>
          <li><Link to='/signup'>Sign Up</Link></li>
          <li><Link to='/signout'>Sign Out</Link></li>
        </AuthSwitch>
      </ul>
    </nav>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js